import { render, staticRenderFns } from "./profile-card-compact.vue?vue&type=template&id=2c04354e"
import script from "./profile-card-compact.vue?vue&type=script&lang=js"
export * from "./profile-card-compact.vue?vue&type=script&lang=js"
import style0 from "./profile-card-compact.vue?vue&type=style&index=0&id=2c04354e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/app/components/ui/Avatar.vue').default})
